<template>
  <avtalat-checkbox
    id="ombud"
    v-model:checked="ombud"
    label="Ombud"
    :disabled="disabled"
  />
</template>

<script setup lang="ts">
const ombud = defineModel<boolean>();

defineProps<{
  disabled?: boolean | null | undefined;
}>();
</script>
